const transforObjetToArr = obj => {
  const arr = [];
  Object.keys(obj).forEach(key => {
    arr.push({ name: key, value: obj[key] });
  });
  return arr;
};

export default transforObjetToArr;
